import { Component, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { SelectItemService } from '../../services/select-item.service';
import { ServiceDataSourceScroller } from '../../services/service-data-source-scroller.model';
import { MensagemControleSituacao } from '../mensagem-controle-situacao.model';
import { MensagemControle } from '../mensagem-controle.model';
import { MensagemControleService } from '../mensagem-controle.service';
import { RespostaProcessamento } from '../resposta-processamento.model';
import { MensagemService, ProgressoService, Restricao, RestricaoOperador, RestricaoPadrao, Restricoes } from 'maestro-ng';

@Component({
  selector: 'app-mensagem-controle-lista',
  templateUrl: './mensagem-controle-lista.component.html',
  styleUrls: ['./mensagem-controle-lista.component.css'],
})
export class MensagemControleListaComponent implements OnInit {
  public ds: ServiceDataSourceScroller<MensagemControle, number>;
  public situacaoItens: SelectItem[];
  public topicoItens: SelectItem[] = [];
  public carregarMensagem = false;

  constructor(
    private service: MensagemControleService,
    private progressoService: ProgressoService,
    private mensagemService: MensagemService,
    private selectItemService: SelectItemService
  ) {
    this.ds = new ServiceDataSourceScroller<MensagemControle, number>(
      this.service,
      this.mensagemService,
      this.progressoService,
      40,
      false
    );
    const situacoes = [MensagemControleSituacao.FALHA_PROCESSAMENTO];
    this.ds.restricoes = new Restricoes([
      new Restricao<number>({ atributo: 'id', operador: RestricaoOperador.EQUALS }),
      new Restricao<string>({ atributo: 'topico', operador: RestricaoOperador.EQUALS }),
      new Restricao<string>({ atributo: 'situacao', operador: RestricaoOperador.IN, valores: situacoes }),
      new Restricao<number>({ atributo: 'particao', operador: RestricaoOperador.EQUALS }),
      new Restricao<string>({ atributo: 'conteudo', operador: RestricaoOperador.CONTAINS }),
      new Restricao<Date>({ atributo: 'auditoriaDataInsercao', operador: RestricaoOperador.LT, padrao: RestricaoPadrao.DATE }),
      new Restricao<string>({ atributo: 'mensagemErro', operador: RestricaoOperador.CONTAINS }),
    ]);
    this.ds.isValid = () => {
      let resultado: boolean;

      if (this.ds.restricoes.atributo('topico').isAtiva()) {
        resultado = true;
      } else {
        this.mensagemService.addAlerta('Atenção', 'É necessario escolher um tópico para iniciar a consulta');
        resultado = false;
      }
      return resultado;
    };
  }

  ngOnInit(): void {
    this.situacaoItens = this.selectItemService.getMensagemControleSituacaoItens();
    this.service
      .recuperarTopicos()
      .then((topicos) => {
        this.topicoItens = topicos.map((topico) => ({ label: topico, value: topico } as SelectItem));
      })
      .catch((resposta) => {
        this.mensagemService.addErro('Erro', 'Erro ao encontrar Tópicos: ' + resposta.message);
      });
  }

  public formatarConteudo(conteudo: string): string {
    return conteudo.split('\\n').join('<br/>');
  }

  public executarNovamente(mensagemControle: MensagemControle): void {
    this.progressoService.modal();
    this.service
      .executarNovamentePorTopicoParticaoEhId(mensagemControle)
      .then((respostaProcessamento) => {
        if (respostaProcessamento === RespostaProcessamento.PROCESSADO) {
          this.mensagemService.addInfo('Sucesso', 'A mensagem id: ' + mensagemControle.id + ' foi processada com sucesso!');
        } else if (respostaProcessamento === RespostaProcessamento.IGNORADO) {
          this.mensagemService.addAlerta(
            'Aviso',
            'A mensagem id: ' + mensagemControle.id + '  foi ignorada, pois já tinha sido processada!'
          );
        } else {
          this.mensagemService.addErro('Erro', 'O processamento id: ' + mensagemControle.id + '  da mensagem falhou novamente!');
        }

        const iof = this.ds.entidades.indexOf(mensagemControle);
        if (iof !== -1) {
          this.ds.entidades.splice(iof, 1);
        }

        this.progressoService.fechar();
      })
      .catch((resposta) => {
        this.mensagemService.addErro(
          'Erro',
          'Erro ao realizar o processamento da mensagem id: ' + mensagemControle.id + '. Error: ' + resposta.message
        );
        this.progressoService.fechar();
      });
  }

  public executarTodosNovamente(listaMensagemControle: MensagemControle[]): void {
    listaMensagemControle.forEach((mensagem) => {
      this.executarNovamente(mensagem);
    });
  }

  public getTipoSituacaoCor(situacao: MensagemControleSituacao): string {
    return this.service.getTipoSituacaoCor(situacao);
  }

  public getTipoSituacaoDescricao(situacao: MensagemControleSituacao): string {
    return this.selectItemService.getMensagemControleSituacaoItens().filter((item) => item.value === situacao)[0].label;
  }

  public toJson(jsonStr: string): any {
    return JSON.parse(jsonStr);
  }
}
